export const validateUrl = (value: string): boolean => {
    try {
        const r = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/.test(value);
        // console.log('validateUrl', {value, r})
        return r;
    } catch (e) {
        console.error(e);
        return false;
    }
}

export const validateEmail = (value: string): boolean => {
    try {
        const regEx = /^([0-9a-zA-Z_\.-]+)@([0-9a-zA-Z_-]+)(\.[0-9a-zA-Z_-]+){1,2}$/;

        return regEx.test(value);
    } catch (e) {
        console.error(e);
        return false;
    }
}

export const validateSpacePath = (value: string): boolean => {
    try {
        console.log(value)
        if (!value) return false
        if (value.trim() === '') return false
        if (value.length < 4) return false
        if (value.length > 20) return false
        const regExTest = /^[a-z0-9-_]{4,20}$/.test(value)
        if (!regExTest) return false
        return true
    } catch (error) {
        return false
    }
}

export const checkSafeInt = (v?: number): boolean => {
    return Number.isSafeInteger(v);
}

export const checkInt4 = (v?: number): boolean => {
    try {
        if (v === undefined) return false;

        const max = 2_147_483_647;
        return Math.abs(v) <= max;
    } catch (e) {
        return false;
    }
}

export const validateInt = (v?: number): true | string => {
    if (isNaN(parseInt(`${v}`))) return '유효한 값(숫자)이 아닙니다.';
    return checkInt4(v) || '허용되지 않는 큰 값(2,147,483,647 초과)이 입력되었습니다.';
}


type Rule = (v?: any, valueSet?: any) => true | string;
export const validateWithRules = (value: any, rules: Rule[] = []) => {
    try {
        const results: string[] = [];
        rules.forEach(rule => {
            if (rule(value) !== true) {
                results.push(rule(value) as string);
            }
        })

        return results;
    } catch (e) {
        console.error(e);
        return ['We have some error!']
    }
}

export const checkIsAppReferrerUrl = (value: string): boolean => {
    if (value.trim() === '') return false
    const regex = /https:\/\/app\.flowing\.space/;
    return regex.test(value)
}
export const checkIsFlowingMallUrl = (value: string): boolean => {
    if (value.trim() === '') return false
    const regex = /https?:\/\/(dev\.)?flowing\.space\/mall/;
    // const regex = /https?:\/\/(www\.)?(dev\.)?flowing\.space\/mall/;
    return regex.test(value)
}
export const checkIsInstagramReelsUrl = (value: string): boolean => {
    if (value.trim() === '') return false
    const regex = /^(https:\/\/)?(www\.)?instagram\.com\/[A-Za-z0-9_-]+\/[A-Za-z0-9_-]+\/?(\?.*)?$/
    return regex.test(value)
}
const validator = {
    validateUrl,
}

export default validator;